(function () {
  'use strict';

  // Rielli: keep the item count on the header cart icon in step with the cart.
  function render(count) {
    document.querySelectorAll('[data-rielli-cart-count]').forEach(function (badge) {
      badge.textContent = count > 9 ? '9+' : String(count);
      badge.hidden = count < 1;
    });
  }

  function refresh() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) { if (cart) render(cart.item_count); })
      .catch(function () {});
  }

  document.addEventListener('theme:cart:loaded', refresh);
  document.addEventListener('theme:cart:added', refresh);
  document.addEventListener('shopify:section:load', refresh);
  // The browser can restore a page from its back/forward cache with an old count
  window.addEventListener('pageshow', function (event) { if (event.persisted) refresh(); });
}());
